import { ofType } from "redux-observable";
import { from } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { actionBaseInfoAddBuilding } from "../../../info/base/actionBaseInfo";
import { actionInventoryInfoRemoveResource } from "../../../info/inventory/actionInventoryInfo";
import { actionBuildingsCancelPlacement, actionBuildingsDeselect, TypeActionBuildings, } from "../actionBuildings";
export var epicBuildingsFinishPlacement = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBuildings.FinishPlacement), switchMap(function (action) {
        var state = state$.value;
        var _a = action.building, balancing = _a.balancing, proto = _a.proto;
        return deps
            .netSend({
            id: action.premium
                ? CommandCode.StartConstructGold
                : CommandCode.StartConstructResource,
            props: {
                farmId: state.playerBase.base.baseId,
                flipped: proto.flipped,
                playerId: state.playerInfo.playerId,
                posX: proto.posX,
                posY: proto.posY,
                typeId: balancing.id,
            },
        })
            .pipe(switchMap(function (res) {
            return from([
                actionBuildingsDeselect(),
                actionBaseInfoAddBuilding(res.building),
                actionInventoryInfoRemoveResource(res.cost),
            ]);
        }), catchError(function () { return from([actionBuildingsCancelPlacement()]); }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingsFinishPlacement.ts
// module id = 2055
// module chunks = 3